import { isAxiosError } from 'axios';

/** TEMP workaround: backend returns no-such-element when draft has no trajectories for the wellbore. */
export function isMissingTrajectoryDraftError(error: unknown): boolean {
  if (!isAxiosError(error)) {
    return false;
  }

  const data = error.response?.data;

  if (typeof data !== 'object' || data === null || !('code' in data)) {
    return false;
  }

  return (data as { code?: unknown }).code === 'no-such-element';
}
